module.exports = __webpack_public_path__ + "static/txdot.74db81d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public_sector_logos/txdot.png
// module id = 2224
// module chunks = 61762850755587